"use strict";
var table = document.querySelector("table");
var ascending = true;
var lastSortedColumn = null;
table.onclick = function(e) {
    if (e.target.tagName !== "TH") return;
    var columnIndex = e.target.cellIndex;
    if (lastSortedColumn === columnIndex) ascending = !ascending;
    else {
        ascending = true;
        lastSortedColumn = columnIndex;
    }
    sortTable(columnIndex);
};
function compareTextValues(textA, textB) {
    var asc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (asc) return textA.localeCompare(textB);
    return textB.localeCompare(textA);
}
function compareNumericValues(numA, numB) {
    var asc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (asc) return numA - numB;
    return numB - numA;
}
function parseCurrency(price) {
    return parseFloat(price.replace("$", "").replace(",", ""));
}
function compareCurrencyValues(priceA, priceB) {
    var asc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var amountA = parseCurrency(priceA);
    var amountB = parseCurrency(priceB);
    if (asc) return amountA - amountB;
    return amountB - amountA;
}
function sortTable(columnIndex) {
    var tbody = table.querySelector("tbody");
    var rows = Array.from(tbody.rows);
    rows.sort(function(a, b) {
        var cellA = a.cells[columnIndex].textContent.trim();
        var cellB = b.cells[columnIndex].textContent.trim();
        if (cellA.includes("$")) return compareCurrencyValues(cellA, cellB, ascending);
        if (!isNaN(cellA)) return compareNumericValues(cellA, cellB, ascending);
        return compareTextValues(cellA, cellB, ascending);
    });
    rows.forEach(function(row) {
        tbody.appendChild(row);
    });
}
var rowsElements = Array.from(document.querySelectorAll("tbody tr"));
rowsElements.forEach(function(rowElement) {
    rowElement.addEventListener("click", function() {
        rowsElements.forEach(function(r) {
            return r.classList.remove("active");
        });
        rowElement.classList.add("active");
    });
});
document.body.append(addNewEmployeeForm());
function addNewEmployeeForm() {
    var newEmployeeName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", newEmployeePosition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", newEmployeeOffice = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Tokyo", newEmployeeAge = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", newEmployeeSalary = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    var newEmployeeForm = document.createElement("form");
    newEmployeeForm.classList.add("new-employee-form");
    newEmployeeForm.innerHTML = '\n    <label>Name: <input data-qa="name" name="name" type="text" value="'.concat(newEmployeeName, '" /></label>\n    <label>Position: <input data-qa="position" name="position" type="text" value="').concat(newEmployeePosition, '" /></label>\n    <label>Office: <select data-qa="office" name="office">\n      <option value="Tokyo">Tokyo</option>\n      <option value="Singapore">Singapore</option>\n      <option value="London">London</option>\n      <option value="New York">New York</option>\n      <option value="Edinburgh">Edinburgh</option>\n      <option value="San Francisco">San Francisco</option>\n    </select></label>\n    <label>Age: <input data-qa="age" name="age" type="number" value="').concat(newEmployeeAge, '" /></label>\n    <label>Salary: <input data-qa="salary" name="salary" type="number" value="').concat(newEmployeeSalary, '" /></label>\n    <button type="submit">Save to table</button>\n  ');
    newEmployeeForm.elements.office.value = newEmployeeOffice;
    newEmployeeForm.addEventListener("submit", function(e) {
        e.preventDefault();
        validateForm(newEmployeeForm);
    });
    return newEmployeeForm;
}
function showNotification(type, description) {
    var existingNotification = document.querySelector('[data-qa="notification"]');
    if (existingNotification) existingNotification.remove();
    var notification = document.createElement("div");
    notification.classList.add("notification", type);
    notification.setAttribute("data-qa", "notification");
    var title = "Error";
    if (type === "success") title = "Success";
    notification.innerHTML = '<span class="title">'.concat(title, "</span> ").concat(description);
    document.body.append(notification);
}
function formatSalary(salary) {
    return "$".concat(Number(salary).toLocaleString("en-US"));
}
function addEmployeeToTable(employeeName, position, office, age, salary) {
    var tbody = document.querySelector("tbody");
    var row = document.createElement("tr");
    row.innerHTML = "\n    <td>".concat(employeeName, "</td>\n    <td>").concat(position, "</td>\n    <td>").concat(office, "</td>\n    <td>").concat(age, "</td>\n    <td>").concat(formatSalary(salary), "</td>\n  ");
    tbody.appendChild(row);
}
function validateForm(newEmployeeForm) {
    var employeeName = newEmployeeForm.elements.name.value;
    var position = newEmployeeForm.elements.position.value;
    var office = newEmployeeForm.elements.office.value;
    var age = newEmployeeForm.elements.age.value;
    var salary = newEmployeeForm.elements.salary.value;
    if (!employeeName || !position || !office || !age || !salary) {
        showNotification("error", "All fields are required");
        return;
    }
    if (employeeName.length < 4) {
        showNotification("error", "Name must be at least 4 characters long");
        return;
    }
    if (Number(age) < 18 || Number(age) > 90) {
        showNotification("error", "Age must be between 18 and 90");
        return;
    }
    var ageValue = Number(age);
    var salaryValue = Number(salary);
    addEmployeeToTable(employeeName, position, office, ageValue, salaryValue);
    showNotification("success", "Employee added successfully");
    newEmployeeForm.reset();
}
var currentlyEditingCell = null;
document.querySelector("tbody").addEventListener("dblclick", function(e) {
    var save = function save() {
        var newValue = input.value.trim();
        if (newValue === "") newValue = oldValue;
        cell.textContent = newValue;
        currentlyEditingCell = null;
    };
    var cell = e.target;
    if (cell.tagName !== "TD") return;
    if (currentlyEditingCell) return;
    currentlyEditingCell = cell;
    var oldValue = cell.textContent;
    var input = document.createElement("input");
    input.classList.add("cell-input");
    input.value = oldValue;
    cell.textContent = "";
    cell.appendChild(input);
    input.focus();
    input.addEventListener("blur", save);
    input.addEventListener("keydown", function(evt) {
        if (evt.key === "Enter") save();
    });
});

//# sourceMappingURL=index.1f10a93d.js.map
